import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {
  currentDomain,
  getCaptchaSitekeyForSignup,
} from "../../utils/general-config";
import { useParams } from "react-router-dom";

let domain = currentDomain();
const RECAPTCHA_SITE_KEY = getCaptchaSitekeyForSignup(domain);

const GoogleCaptcha = ({ onCaptchaSuccess }) => {
  const recaptchaRef = useRef();
  const { locale } = useParams();
  const handleChange = (token) => {
    if (!token) return;
    console.log("Captcha success, token:", token);
    onCaptchaSuccess(token);
  };

  return (
    <div>
      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY}
        ref={recaptchaRef}
        theme="light"
        onChange={handleChange}
        hl={locale}
      />
    </div>
  );
};

export default GoogleCaptcha;
